import React, { useContext } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { Button, message, Modal } from "antd";
import {
    NavState,
    publishGrade,
    PublishStatus
} from "../../../../../service/score";
import { errorMessage } from "service/service";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import moment from "moment/moment";
import { useAtom } from "jotai";
import { countAtom } from "../../store";
import ScoreBaseContext from "../../context";
import useModalHandler from "../../../../../utils/v3/useModalHandler";
import CheckModal from "./Components/CheckModal";
import { CountModalButton } from "./Components/CountModalButton";

interface NavBarProps {
    mark: NavState;
    onChange: (val: number) => void;
    courseNo: string;
    courseSeq: string;
    refreshData: () => void; //刷新成绩单
    status: PublishStatus | null; //成绩单发布状态obj
}

export default function NavBar({
    mark,
    onChange,
    courseNo,
    courseSeq,
    refreshData,
    status: data
}: NavBarProps) {
    const [publishFn, state] = useRequestFn(publishGrade);
    const { Operator, OperatorLoading, ReloadOperator } =
        useContext(ScoreBaseContext);
    const [, setCount] = useAtom(countAtom);

    const checkModal = useModalHandler({ component: CheckModal });

    async function doPublish() {
        const params = {
            courseNo,
            courseSeq,
            teachUnit: data?.teachUnit,
            isProcess: data?.isProcess,
            hasPublished: "1",
            hasChanged: data?.hasChanged,
            delStatus: data?.delStatus
        };

        try {
            await publishFn(params);
            await refreshData();
            await setCount(atom => atom + 1);
            await ReloadOperator();
            message.success("发布成功");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const handlePublish = async () => {
        Modal.confirm({
            title: `确定发布？`,
            content:
                "发布成绩单后，学生端可以查看成绩，但教师将无法撤回或再编辑成绩。教师新建教学互动或学生新参与互动将不被计入成绩中，请核对成绩无误后再发布成绩单。",
            onOk: async () => {
                try {
                    await doPublish();
                } catch (e) {
                    ResultMessage.error(errorMessage(e));
                }
            }
        });
    };

    const handleCancelPublish = async () => {
        const params = {
            courseNo,
            courseSeq,
            teachUnit: data?.teachUnit,
            isProcess: data?.isProcess,
            hasPublished: "0",
            hasChanged: data?.hasChanged,
            delStatus: data?.delStatus
        };
        try {
            await publishFn(params);
            await refreshData();
            await setCount(count => count + 1);
            await ReloadOperator();
            message.success("取消成功");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const formatTime = (date?: string) => {
        if (!date) {
            return "";
        }

        return moment(date).format("MM-DD HH:mm");
    };

    function openCheck() {
        checkModal.open({
            courseSeq,
            courseNo,
            onSuccess: () => {
                checkModal.close();
            }
        });
    }

    return (
        <div className={style.root}>
            <div className={style.links}>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 0
                    })}
                    onClick={() => onChange(0)}>
                    成绩规则
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 1
                    })}
                    onClick={() => onChange(1)}>
                    成绩单
                </div>
            </div>

            <div className={style.right}>
                <CountModalButton courseNo={courseNo} courseSeq={courseSeq} />

                {mark === NavState.Paper && (
                    <React.Fragment>
                        <Button
                            style={{ display: "none" }}
                            type="primary"
                            onClick={handleCancelPublish}
                            loading={state.loading}>
                            取消发布成绩单
                        </Button>
                        <Button
                            type="primary"
                            onClick={openCheck}
                            loading={state.loading || OperatorLoading}>
                            发布前校验
                        </Button>
                        <Button
                            type="primary"
                            onClick={handlePublish}
                            disabled={!Operator?.push}
                            loading={state.loading || OperatorLoading}>
                            发布成绩单
                        </Button>
                    </React.Fragment>
                )}
            </div>

            {checkModal.render()}
        </div>
    );
}
